/**
 * Carousel Wrapper
 * @param {object} $container [jQuery]
 */
function Carousel($container) {
	'use strict';
	this.$carousel = $container;
	this.$items = $container.find('.carousel__item');
	this.config = {};
}

Carousel.prototype = {

	/**
	 * @param  {object} config
	 * @return {Carousel}
	 */
	init: function (config) {
		'use strict';
		if (!$.fn.jCarouselLite || !this.$carousel.length) {
			return;
		}

		this.numVisible = this.getVisibleCount();
		$.extend(this.config, this.getDefaultConfig(), config);
		this.$carousel.jCarouselLite(this.config);
		this.$items.show();

		return this;
	},

	/**
	 * Default configuration, can be overriden on init
	 * @return {object}
	 */
	getDefaultConfig: function () {
		'use strict';
		return {
			speed: 600,
			visible: this.numVisible,
			scroll: this.numVisible,
			circular: false
		};
	},

	/**
	 * Determine numberof visible items
	 * @return {number}
	 */
	getVisibleCount: function () {
		'use strict';
		var carouselWidth, itemWidth, maxVisible;

		carouselWidth = this.$carousel.outerWidth();
		itemWidth = this.$items.eq(1).outerWidth();
		maxVisible = Math.floor(carouselWidth / itemWidth);

		//Don't allow space for more than we have
		return Math.min(maxVisible, this.$items.length);
	}
};

export default Carousel;